module.exports = __webpack_public_path__ + "static/media/image.97c1e653.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/image.jpg
// module id = 317
// module chunks = 0